import { render, staticRenderFns } from "./EditBarcodeRecognition.vue?vue&type=template&id=b66335b4&scoped=true&"
import script from "./EditBarcodeRecognition.vue?vue&type=script&lang=js&"
export * from "./EditBarcodeRecognition.vue?vue&type=script&lang=js&"
import style0 from "./EditBarcodeRecognition.vue?vue&type=style&index=0&id=b66335b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66335b4",
  null
  
)

export default component.exports